(() => {
  const root = document.querySelector('[data-ttd-hero]');
  if (root) {
    const slides = [...root.querySelectorAll('[data-hero-slide]')];
    const dots = [...root.querySelectorAll('[data-hero-dot]')];
    let i = 0;
    const show = (n) => {
      i = (n + slides.length) % slides.length;
      slides.forEach((el, idx) => {
        el.hidden = idx !== i;
      });
      dots.forEach((el, idx) => el.classList.toggle('active', idx === i));
      const g = slides[i]?.dataset.gradient;
      if (g) root.style.background = g;
    };
    let timer = null;
    const restartTimer = () => {
      if (slides.length < 2) return;
      clearInterval(timer);
      timer = setInterval(() => show(i + 1), 5200);
    };
    dots.forEach((dot, idx) =>
      dot.addEventListener('click', () => {
        show(idx);
        restartTimer();
      }),
    );

    // Touch swipe between slides
    let touchX = null;
    let touchY = null;
    root.addEventListener(
      'touchstart',
      (e) => {
        touchX = e.touches[0].clientX;
        touchY = e.touches[0].clientY;
      },
      { passive: true },
    );
    root.addEventListener(
      'touchend',
      (e) => {
        if (touchX === null) return;
        const dx = e.changedTouches[0].clientX - touchX;
        const dy = e.changedTouches[0].clientY - touchY;
        touchX = touchY = null;
        if (Math.abs(dx) > 44 && Math.abs(dx) > Math.abs(dy) * 1.5) {
          show(dx < 0 ? i + 1 : i - 1);
          restartTimer();
        }
      },
      { passive: true },
    );

    restartTimer();
    show(0);
  }

  // Scroll-reveal, homepage only, skipped for reduced-motion users
  if (
    root &&
    'IntersectionObserver' in window &&
    !window.matchMedia('(prefers-reduced-motion: reduce)').matches
  ) {
    const targets = [...document.querySelectorAll('main section')].filter((el) => el !== root);
    if (targets.length) {
      document.documentElement.classList.add('ttd-reveal');
      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-in');
              io.unobserve(entry.target);
            }
          });
        },
        { rootMargin: '0px 0px -8% 0px' },
      );
      targets.forEach((el) => io.observe(el));
    }
  }

  document.querySelectorAll('[data-faq-item]').forEach((item) => {
    const btn = item.querySelector('button');
    const panel = item.querySelector('[data-faq-panel]');
    if (!btn || !panel) return;
    btn.addEventListener('click', () => {
      const open = item.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', String(open));
      panel.hidden = !open;
    });
  });

  // Quick add-to-cart for TTD product cards; refreshes and opens the cart drawer
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-quick-add]');
    if (!btn || btn.disabled) return;
    const id = Number(btn.dataset.quickAdd);
    if (!id) return;
    const label = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding…';
    try {
      const drawer = document.querySelector('cart-drawer');
      const sections = drawer ? drawer.getSectionsToRender().map((s) => s.id) : [];
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id, quantity: 1 }],
          sections: sections.join(','),
          sections_url: window.location.pathname,
        }),
      });
      if (!res.ok) throw new Error('add failed');
      const data = await res.json();
      if (drawer && data.sections) {
        drawer.renderContents(data);
        btn.textContent = 'Added ✓';
      } else {
        window.location.href = '/cart';
        return;
      }
    } catch (err) {
      btn.textContent = 'Try again';
    }
    btn.disabled = false;
    setTimeout(() => {
      btn.textContent = label;
    }, 2000);
  });

  const gate = document.querySelector('[data-age-gate]');
  if (gate && !sessionStorage.getItem('ttd-age')) {
    document.body.classList.add('locked');
    gate.hidden = false;
    gate.querySelector('[data-age-yes]')?.addEventListener('click', () => {
      sessionStorage.setItem('ttd-age', '1');
      gate.hidden = true;
      document.body.classList.remove('locked');
    });
    gate.querySelector('[data-age-no]')?.addEventListener('click', () => {
      window.location.href = 'https://www.google.com';
    });
  } else if (gate) {
    gate.hidden = true;
  }
})();
